import * as ActionTypes from '../ActionTypes';

const componentInitialState = {
    isLoading: false,
    success: false,
    error: false,
    wage_report_data: [],
    wage_report_notprocessed_data : [],
    daily_wage_report_data: [],
    daily_wage_report_notprocessed_data : [],
    contractual_wage_report_data: [],
    contractual_wage_report_notprocessed_data : [],
}

export const WageReportsReducer = function (state = componentInitialState, action) {
    switch (action.type) {
        case ActionTypes.WAGE_REPORT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.WAGE_REPORT_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                wage_report_data: action.payload?.data?.data
            };
        case ActionTypes.WAGE_REPORT_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.WAGE_REPORT_NOT_PROCESSED_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                wage_report_notprocessed_data: action.payload?.data?.data
            };
        case ActionTypes.WAGE_REPORT_NOT_PROCESSED_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.CONTRACTUAL_WAGE_REPORT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.CONTRACTUAL_WAGE_REPORT_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                contractual_wage_report_data: action.payload?.data?.data
            };
        case ActionTypes.CONTRACTUAL_WAGE_REPORT_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                contractual_wage_report_notprocessed_data: action.payload?.data?.data
            };
        case ActionTypes.CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
       case ActionTypes.DAILY_WAGE_REPORT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.DAILY_WAGE_REPORT_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                daily_wage_report_data: action.payload?.data?.data
            };
        case ActionTypes.DAILY_WAGE_REPORT_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.DAILY_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.DAILY_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                daily_wage_report_notprocessed_data: action.payload?.data?.data
            };
        case ActionTypes.DAILY_WAGE_REPORT_NOT_PROCESSED_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
       
        default:
            return state;
    }
}